import { Component, ContentChild, EventEmitter, Input, Output, ViewChild, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { ModalComponent } from 'ngx-boot-modal';
import { AbstractEditionModalForm } from './abstract-edition-modal-form';

@Component({
  selector: 'app-edition-modal',
  templateUrl: './edition-modal.component.html',
  styleUrls: ['./edition-modal.component.css']
})
export class EditionModalComponent<T> implements AfterViewChecked {

  @Input() title: string;
  @Input() titleParams: { [key: string]: any };
  @Input() saveLabel = 'shared.edit.save';
  @Input() cancelLabel = 'shared.edit.cancel';
  @Input() modalClass: string;
  @Input() showFooter = true;
  @Input() showCancelButton = true;
  @Output() cancel = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();
  @ViewChild(ModalComponent) modal: ModalComponent;
  @ContentChild(AbstractEditionModalForm) formComponent: AbstractEditionModalForm<T>;

  constructor (
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  open(model?: T, params?: any) {
    this.formComponent.updateForm(model, params);
    this.modal.open();
  }

  close() {
    this.modal.close();
  }

  onCancel() {
    this.close();
    this.cancel.emit();
  }

  onSave() {
    this.save.emit(this.formComponent.getFormData());
  }

  get saveDisabled() {
    return (this.formComponent && this.formComponent.form) ? this.formComponent.form.invalid : true;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/edition-modal/edition-modal.component.ts